<ng-container *ngIf="suggestedProducts$ | async as suggestProducts">
  <div *ngIf="suggestProducts.length" class="product-list-container suggest-details">
    <h2>{{ productLinkTitle }}</h2>
    <div class="product-list" [ngClass]="getClass(suggestProducts.length)">
      <ng-container
        *ngFor="let suggestedProduct of suggestProducts; let suggestedProductIndex = index"
        ishProductContext
        [sku]="suggestedProduct.sku"
      >
        <div *ngIf="suggestedProductIndex < 3" class="product-list-item list-view">
          <div class="row">
            <div class="product-image-container col-5">
              <ish-product-image imageType="S" [link]="true"></ish-product-image>
            </div>
            <div class="col-7 suggest-prod-info">
              <ish-product-name></ish-product-name>
              <div>{{ suggestedProduct.sku }}</div>
              <ish-product-price [showInformationalPrice]="true"></ish-product-price>
            </div>
          </div>
          <div class="row">
            <div class="col-6 p-2 action-container">
              <ish-product-quantity></ish-product-quantity>
            </div>
            <div class="col-6 p-2 action-container">
              <ish-product-add-to-basket></ish-product-add-to-basket>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
